/**
 * The last few records this person opened from search, for the search
 * palette's "Recent" list (UX-115). Per device (localStorage) — a convenience,
 * not data: a private window or blocked storage simply shows no recents.
 */
export interface RecentRecord {
  /** `${section}:${id}` — dedupe key */
  key: string
  label: string
  sub?: string
  path: string
  /** Search section, so the palette can show the right icon. */
  section: string
}

const KEY = 'search.recent.v1'
export const RECENT_LIMIT = 5

export function readRecents(): RecentRecord[] {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw) as unknown
    if (!Array.isArray(parsed)) return []
    return parsed
      .filter((r): r is RecentRecord =>
        !!r && typeof r === 'object' && typeof (r as RecentRecord).key === 'string'
        && typeof (r as RecentRecord).label === 'string' && typeof (r as RecentRecord).path === 'string')
      .slice(0, RECENT_LIMIT)
  } catch {
    return []
  }
}

/** Newest first; re-opening a record moves it to the top. */
export function rememberRecent(record: RecentRecord): void {
  try {
    const next = [record, ...readRecents().filter((r) => r.key !== record.key)].slice(0, RECENT_LIMIT)
    localStorage.setItem(KEY, JSON.stringify(next))
  } catch {
    /* storage unavailable — recents are optional */
  }
}
